import { z } from 'zod';

export const CompanyParser = z.object({
  companyId: z.string().optional().catch(''),
});

export type CompanyFilterType = z.infer<typeof CompanyParser>;
